import { useSyncExternalStore } from 'react';

import { maintenanceStore } from './useMaintenanceMode.store';

export const useMaintenanceMode = () => useSyncExternalStore(maintenanceStore.subscribe, maintenanceStore.getSnapshot);
